module.exports = __webpack_public_path__ + "img/pin.9cd6779d.svg";